export const trashApi = (client) => ({
    list: () => client.get('/api/v1/trash').then((r) => r.data),
    restore: (module, id) => client.post(`/api/v1/trash/${module}/${id}/restore`).then((r) => r.data),
    permanentDelete: (module, id) => client.delete(`/api/v1/trash/${module}/${id}`).then((r) => r.data),
});
//# sourceMappingURL=trash.js.map